import { disconnectEcho, getEcho } from './echo';

let activeChannel = null;
let activeChannelName = null;

function dispatchNotificationEvent(name, payload) {
    window.dispatchEvent(new CustomEvent(name, { detail: payload }));
}

/**
 * Subscribe to the authenticated user's private notification channel.
 */
export function subscribeNotificationChannel(tenantId, userId) {
    if (!tenantId || !userId) {
        return;
    }

    const channelName = `tenant.${tenantId}.user.${userId}`;

    if (activeChannelName === channelName) {
        return;
    }

    unsubscribeNotificationChannel();

    const echo = getEcho();
    if (!echo) {
        console.warn('[notifications] Echo not initialized — check VITE_REVERB_* and rebuild assets');
        return;
    }

    activeChannelName = channelName;
    activeChannel = echo
        .private(channelName)
        .listen('.notification.created', (event) => {
            dispatchNotificationEvent('notification:created', event);
        })
        .listen('.notification.read', (event) => {
            dispatchNotificationEvent('notification:read', event);
        })
        .listen('.generated-report.updated', (event) => {
            dispatchNotificationEvent('generated-report:updated', event);
        })
        .listen('.non-interactive-video.ready', (event) => {
            dispatchNotificationEvent('non-interactive-video:ready', event);
        });

    if (import.meta.env.DEV) {
        console.info('[notifications] subscribed', channelName);
    }
}

export function unsubscribeNotificationChannel() {
    if (!activeChannelName) {
        return;
    }

    try {
        const echo = window.Echo ?? getEcho();
        echo.leave(activeChannelName);
    } catch (e) {
        // Channel may already be gone after disconnect.
    }

    activeChannel = null;
    activeChannelName = null;

    if (import.meta.env.DEV) {
        console.info('[notifications] unsubscribed');
    }
}

/**
 * Wire realtime notifications to Vuex auth state.
 * Call once from main.js after the store is registered.
 */
export function initNotificationRealtime(store) {
    const trySubscribe = () => {
        const user = store.getters.getCurrentUser;
        const tenant = store.state.currentTenant;

        if (user?.id && tenant?.id) {
            subscribeNotificationChannel(tenant.id, user.id);
        }
    };

    // Persisted session from vuex-persist on first load.
    trySubscribe();

    store.subscribe((mutation) => {
        if (mutation.type === 'SET_CURRENT_CONTEXT') {
            trySubscribe();
        }

        if (mutation.type === 'LOGOUT_USER') {
            unsubscribeNotificationChannel();
            disconnectEcho();
        }
    });
}
